__turbopack_context__.v({
  "authorsComments": "BoardSectionItemArticle-module-scss-module__6wKM6q__authorsComments",
  "commentsLink": "BoardSectionItemArticle-module-scss-module__6wKM6q__commentsLink",
  "content": "BoardSectionItemArticle-module-scss-module__6wKM6q__content",
  "dot": "BoardSectionItemArticle-module-scss-module__6wKM6q__dot",
  "footer": "BoardSectionItemArticle-module-scss-module__6wKM6q__footer",
  "header": "BoardSectionItemArticle-module-scss-module__6wKM6q__header",
  "isHero": "BoardSectionItemArticle-module-scss-module__6wKM6q__isHero",
  "isLargeWrapper": "BoardSectionItemArticle-module-scss-module__6wKM6q__isLargeWrapper",
  "line": "BoardSectionItemArticle-module-scss-module__6wKM6q__line",
  "metaModules": "BoardSectionItemArticle-module-scss-module__6wKM6q__metaModules",
  "relatedLink": "BoardSectionItemArticle-module-scss-module__6wKM6q__relatedLink",
  "teaser": "BoardSectionItemArticle-module-scss-module__6wKM6q__teaser",
  "title": "BoardSectionItemArticle-module-scss-module__6wKM6q__title",
  "wrapper": "BoardSectionItemArticle-module-scss-module__6wKM6q__wrapper",
});
